import { regIsTer } from "@/libs/api";
import { quickRegister } from "@/libs/api";
import { setTimeout } from "core-js";

export default {
    name: "join",
    data() {
        return {
            areaIf: false,
            timeif: false,
            yantext: "获取验证码",
            phoneNum: "",
            validNum: "",
            loadhide: false,
            maskhide: false,
            quickReg: "",
            recommendUsrOnlyid: "",
            channel: "",
            setDivHeight: "",
        };
    },
    mounted() {
        this.recommendUsrOnlyid = this.$route.query.recommendUsrOnlyid;
        this.shareId=this.$route.query.shareId;
        console.log(this.shareId); //分享id      
        document.querySelector("body").classList.add("bg-fff");
        this.$once("hook:beforeDestroy", () => {
            document.querySelector("body").classList.remove("bg-fff");
        });
        document.cookie = `ul_sch=ylxdsq;domain=.${this.$uleUrl()};path=/;expires=3600`;
        this.setDivHeight = document.body.offsetHeight;
    },
    methods: {
        areaCheck() {
            this.areaIf = !this.areaIf;
        },
        //  获取验证码
        verIfication() {
            if (!this.timeif) {
                if (this.phoneNum == "") {
                    return this.$toast("手机号不能为空哦^_~");
                } else if (!this.isMobile(this.phoneNum)) {
                    return this.$toast("一定要填写正确的手机号哦^_~");
                }
                let params = {
                    mobile: this.phoneNum,
                    clientType: "app_ylxdsq",
                };
                this.loadhide = true;
                regIsTer(params, "jsoncallback").then((res) => {
                    this.loadhide = false;
                    if (res.returnCode == "0000") {
                        this.timeif = true;
                        this.$toast("短信验证码发送成功");
                        this.countdown(60);
                    } else {
                        this.$toast(res.returnMessage);
                    }
                });
            }
        },
        // 注册
        regIster() {
            if (this.phoneNum == "") {
                return this.$toast("手机号不能为空哦^_~");
            } else if (!this.isMobile(this.phoneNum)) {
                return this.$toast("一定要填写正确的手机号哦^_~");
            }
            if (this.validNum == "") {
                return this.$toast("验证码不能为空哦^_~");
            } else if (this.validNum.length < 6 || this.validNum.length > 6) {
                return this.$toast("验证码是6位数字哦^_~");
            }
            this.loadhide = true;
            let params = {
                mobile: this.phoneNum,
                validateCode: this.validNum,
                recommendUsrOnlyid: this.recommendUsrOnlyid,
                recommendChannel: "app_ylxdsq",
                shareId:this.shareId
            };
            quickRegister(params, "jsoncallback").then((res) => {
                this.loadhide = false;
                if (res.returnCode == "0000") {
                    //  注册成功逻辑
                    this.maskhide = true;
                    this.quickReg = res.data.quickRegisterAuto;
                } else {
                    this.$toast(res.returnMessage);  
                }
            });
        },
        // 倒计时
        countdown(t) {
            let m = this;
            if (--t < 1) {
                m.yantext = "重获验证码";
                m.timeif = false;
            } else {
                m.yantext = t + " 秒";
                m.countFlag = setTimeout(function() {
                    m.countdown(t);
                }, 1000);
            }
        },
        // 校验手机
        vdMobile() {
            let m = this;
            if (m.phoneNum == "") {
                this.$toast("手机号不能为空哦^_~");
            } else if (!m.isMobile(m.phoneNum)) {
                this.$toast("一定要填写正确的手机号哦^_~");
            }
        },
        isMobile(phoneNum) {
            return new RegExp(/^1[3|4|5|6|7|8|9][0-9]{9}$/).test(
                phoneNum.trim()
            );
        },
        toDownload() {
            setTimeout(() => {
                window.location =
                    "https://a.app.qq.com/o/simple.jsp?pkgname=com.ule.storecommunity";
            }, 1000);
        },
        doCopy() {
            this.copyText(this.quickReg, this.toDownload, this.toDownload);
        },
    },
};
